// Personal email providers (not allowed for business accounts)
export const unacceptedEmailProviders = [
    'aol', 'gmail', 'yahoo', 'hotmail', 'outlook',
    'icloud', 'inbox', 'live', 'comcast', 'msn',
];

// Competitor domains (blocked)
export const blockedDomains = [
    'getbuilt', 'procore', 'rabbet', 'ingeniousio', 'avidxchange',
    'nexussystems', 'yardi', 'mrisoftware', 'dealpath', 'junipersquare',
    'buildertrend', 'withbanner', 'br.iq',
];

/**
 * Validates if an email domain is allowed for signup
 * Matches the yup validation logic: checks if email contains @provider. or @domain.
 * @param email - The email address to validate
 * @returns Object with isValid boolean and optional errorMessage
 */
export const validateEmailDomain = (email: string): { isValid: boolean; errorMessage?: string } => {
    if (!email) {
        return { isValid: true };
    }

    const lowerEmail = email.toLowerCase();

    const hasPersonalEmailProvider = unacceptedEmailProviders.some(provider => lowerEmail.includes(`@${provider}.`));
    if (hasPersonalEmailProvider) {
        return {
            isValid: false,
            errorMessage: 'Please use a valid business email address.',
        };
    }

    const hasBlockedDomain = blockedDomains.some(domain => lowerEmail.includes(`@${domain}.`));
    if (hasBlockedDomain) {
        return {
            isValid: false,
            errorMessage: 'We are not accepting new signups at this time',
        };
    }

    return { isValid: true };
};
